import React, { useState, useCallback } from 'react';

import { ReactComponent as ThunderIcon } from 'assets/images/icons/thunder.svg';
import { ReactComponent as WebAgenciesIcon } from 'assets/images/icons/web_agencies.svg';
import { ReactComponent as ServiceProvidersIcon } from 'assets/images/icons/service_providers_icon.svg';

import LoadingImage from 'assets/images/image_loading.svg';

import WebAgenciesImage from 'assets/images/web_agency.svg';
import RetailsImage from 'assets/images/retails.svg';
import ServiceProvidersImage from 'assets/images/service_providers.svg';

import {
  Wrapper,
  SwitchBlockItem,
  SwitchItemWrapper,
  SwitchItem,
  SwitchItemTitle,
  SwitchItemDescription,
  SwitchItemImage,
  SwitchItemIcon,
} from './styled';

const items = [
  {
    id: 'retailers',
    title: 'Retailers',
    icon: ThunderIcon,
    description: [
      'Our solutions are up and running in many Shopping',
      <br key='some' />,
      'Malls, Premium Outlets and Department stores',
    ],
  },
  {
    id: 'web_agencies',
    title: 'Web agencies',
    icon: WebAgenciesIcon,
    description: [
      'We build and manage cloud solutions for delivering',
      <br key='some' />,
      'optimal web services',
    ],
  },
  {
    id: 'service_providers',
    title: 'Service providers',
    icon: ServiceProvidersIcon,
    description: [
      'Our proven know-how in enterprise networks can ',
      <br key='some' />,
      'help delivering advanced email and backup services',
    ],
  },
];

const getImg = (activeKey) => {
  switch (activeKey) {
    case 'retailers':
      return RetailsImage;
    case 'web_agencies':
      return WebAgenciesImage;
    case 'service_providers':
      return ServiceProvidersImage;
    default:
      return null;
  }
};

const ItemImage = ({ activeKey }) => {
  const getImg = () => {
    switch (activeKey) {
      case 'retailers':
        return RetailsImage;
      case 'web_agencies':
        return WebAgenciesImage;
      case 'service_providers':
        return ServiceProvidersImage;
      default:
        return null;
    }
  };

  return <SwitchItemImage src={getImg(activeKey)} />;
};

const CustomerSwitcher = ({ activeKey, onClick }) => {
  const [loadedStatuses, setLoadedStatuses] = useState({
    retailers: false,
    web_agencies: false,
    service_providers: false,
  });

  const onLoading = useCallback((key) => {
    setLoadedStatuses((state) => ({
      ...state,
      [key]: true,
    }));
  }, []);

  return (
    <Wrapper>
      <SwitchBlockItem>
        {items.map((i) => (
          <SwitchItemWrapper
            role='presentation'
            active={activeKey === i.id}
            key={i.id}
            onClick={() => onClick(i.id)}
          >
            <SwitchItem active={activeKey === i.id} >
              <SwitchItemIcon as={i.icon} />
              <div style={{ paddingTop: 3 }}>
                <SwitchItemTitle>{i.title}</SwitchItemTitle>
                <SwitchItemDescription>{i.description}</SwitchItemDescription>
              </div>
            </SwitchItem>
          </SwitchItemWrapper>
        ))}
      </SwitchBlockItem>
      <SwitchBlockItem isImage={true}>
        <SwitchItemImage
          src={loadedStatuses[activeKey] ? getImg(activeKey) : LoadingImage}
          onLoad={() => onLoading(activeKey)}
        />
      </SwitchBlockItem>
    </Wrapper>
  );
};

export default CustomerSwitcher;
